import type { FormEventHandler } from "react";
import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import EmailInput from "./EmailInput";
import Logo from "../../assets/img/skorLogo.svg";
import { useNavigate } from "react-router-dom";
import type { AccountType } from "../../pages/auth/authFlow";
import styles from "../../pages/onboarding/BasicInfoModal.module.css";

interface EmailFormProps {
  usedFor: AccountType;
  email: string;
  onChangeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled: boolean;
  emailSubmitHandler: FormEventHandler<HTMLFormElement>;
  loading?: boolean;
  companyLogo?: string | null;
  from?: string | null;
  isInvitedEmail?: boolean;
}

const EmailForm = ({
  usedFor,
  email,
  onChangeHandler,
  disabled,
  emailSubmitHandler,
  loading = false,
  companyLogo,
  from,
  isInvitedEmail,
}: EmailFormProps) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();

  const handleNavigate = (userType: AccountType) => {
    navigate(userType === "tenant" ? "/landlord/auth" : "/tenant/auth");
  };

  return (
    <div className="formInformation">
      <div className="form_logo form_logo_mobile">
        {haveValue(companyLogo) ? (
          <>
            <img className="company-logo" src={`${companyLogo}`} alt="" />
            <div className="d-flex align-items-center justify-content-center custom-gap-2 poweredByWrapper">
              <p className="poweredBy">{_t("poweredBy")}</p>
              <img src={Logo} alt="Powered By Logo" className="poweredByLogo" />
            </div>
          </>
        ) : (
          <img src={Logo} alt="logo" />
        )}
      </div>
      <button
        type="button"
        onClick={() =>
          from === "website"
            ? window.location.replace("https://skortorent.com/")
            : navigate("/auth")
        }
        className={styles.backButton}
      >
        <span aria-hidden="true">&#8249;</span>
        {_t("back")}
      </button>
      <div className="landlord-form-heading">
        <h2>{usedFor === "tenant" ? _t("tenant") : _t("landlord")}</h2>
      </div>
      <p className="form-inner-p">
        {usedFor === "tenant"
          ? _t(
              "helpingUsersBuildProfileForFasterApprovalsFromLandlordsAndAgentsToHelpThemMakeTheirDreamPlaceHome"
            )
          : _t("helpingLandlordsShowcasePropertiesForQuickerUserMatches")}
      </p>
      <form onSubmit={emailSubmitHandler}>
        <EmailInput
          value={email}
          onChange={onChangeHandler}
          disabled={disabled || isInvitedEmail}
        />
        <button
          disabled={disabled}
          type="submit"
          className="btnNext basicInfoButton greenHover d-flex align-items-center justify-content-center"
        >
          {loading ? (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-label={_t("loading")}
            />
          ) : (
            _t("getStarted")
          )}
        </button>
      </form>
      <div className="continue-other-link">
        <p>{_t("doYouWantToContinueAs")} </p>
        <span onClick={() => handleNavigate(usedFor)}>
          {usedFor === "tenant" ? _t("landlord") : _t("tenant")}{" "}
        </span>
      </div>
    </div>
  );
};

export default EmailForm;
